import { createAppWrapper } from "@/common.js";
import SsoSessionNew from "@/sessions/SsoLogin.vue";

document.addEventListener("DOMContentLoaded", () => {
  createAppWrapper(SsoSessionNew);
});
